"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GlobalStyle = void 0;
Object.defineProperty(exports, "scrollbarStyle", {
  enumerable: true,
  get: function () {
    return _index.baseScrollbarStyle;
  }
});
var _styledComponents = require("styled-components");
var _index = require("../../_nextgen/components/Scrollbar/index.styled");
const isIframe = window.top !== window.self;
const GlobalStyle = exports.GlobalStyle = (0, _styledComponents.createGlobalStyle)`
  body {
    @media (pointer: fine) {
      * {
        ${_index.baseScrollbarStyle}
      }
    }
  }
  ${isIframe && `
    body {
      ${_index.baseScrollbarStyle}
    }
  `}
`;
var _default = exports.default = GlobalStyle;